import React, { useState, useEffect } from "react";
import axios from "axios";
import MyLoader from "../Spinner/MyLoader";
import COLORS from "../resources/colors/COLORS";
import SessionManager from "../Utils/SessionManager";
import { Redirect, useParams } from "react-router-dom";
import "../css/Admin_css/admin-customize.css";
import myToast from "../Utils/MyToast";
import Iframe from "react-iframe";
import MdlSelectMultipleStudent from "../dialog/MdlSelectMultipleStudent";

const PrintableDocs = () => {
  const { document_type } = useParams();

  const [loggedIn, setLoggedIn] = useState(!!localStorage.getItem("token"));
  const [Loading, setLoading] = useState(false);
  const [isOpenSelectStudent, setIsOpenSelectStudent] = useState(false);
  const [showStudentIdCard, setShowStudentIdCard] = useState(false);
  const [mSelectedStudent, setMSelectedStudent] = useState([]);
  const [mPrintableSamples, setMPrintableSamples] = useState([]);
  const [mColorOption, setMColorOption] = useState([]);
  const [FILE_URL, setFILE_URL] = useState("");
  const [FILE_NAME, setFILE_NAME] = useState("");
  const [FILE_DIRECTORY, setFILE_DIRECTORY] = useState("");
  const [DOCUMENT_TYPE] = useState(document_type);
  const [SELECTED_SAMPLE_ID, setSELECTED_SAMPLE_ID] = useState("");
  const [SELECTED_SAMPLE_POSITION, setSELECTED_SAMPLE_POSITION] = useState(0);
  const [SELECTED_COLOR_POSITION, setSELECTED_COLOR_POSITION] = useState(0);
  const [COLOR_OPTION_ID, setCOLOR_OPTION_ID] = useState("");
  const [SELECTION_TYPE, setSELECTION_TYPE] = useState("");

  useEffect(() => {
    getPrintableSamples();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getPrintableSamples = () => {
    setLoading(true);
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const FUNCTION_NAME = "getPrintableSample.php?";
    const URL =
      process.env.REACT_APP_SERVER_NAME +
      process.env.REACT_APP_TARGET_DIR +
      FUNCTION_NAME;

    axios
      .get(URL, {
        params: {
          school_code: SCHOOL_CODE,
          document_type: DOCUMENT_TYPE,
        },
      })
      .then((res) => res.data)
      .then((response) => {
        setLoading(false);
        if (response.api_status === "OK") {
          setMPrintableSamples(response.data);
          setSample(SELECTED_SAMPLE_POSITION, response.data);
        } else {
          myToast.notify_warning(response.api_remark);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log("error>>>>>" + error);
      });
  };

  const setSample = (selected_sample_position, samples = mPrintableSamples) => {
    const sample = samples[selected_sample_position];
    setFILE_NAME(sample.file_name);
    setFILE_DIRECTORY(sample.file_directory);
    setSELECTED_SAMPLE_ID(sample.sample_id);
    getColorOptions(selected_sample_position, samples);
  };

  const getColorOptions = (
    selected_sample_position,
    samples = mPrintableSamples
  ) => {
    const colorOptions = samples[selected_sample_position].color_options || [];
    setMColorOption(colorOptions);
    setColorOptions(SELECTED_COLOR_POSITION, colorOptions);
  };

  const setColorOptions = (
    selected_position_color_option,
    colorOptions = mColorOption
  ) => {
    const selectedColor = colorOptions[selected_position_color_option];
    setCOLOR_OPTION_ID(selectedColor ? selectedColor.color_option_id : "");

    if (mSelectedStudent.length > 0) {
      setFileUrL();
    }
  };

  const setFileUrL = () => {
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    let session_id = "";
    const mStudentIds = mSelectedStudent.map((student) => {
      session_id = student.session_id;
      return student.student_enrollment_no;
    });

    const url =
      process.env.REACT_APP_SERVER_NAME +
      FILE_DIRECTORY +
      FILE_NAME +
      "?&student_ids=" +
      JSON.stringify(mStudentIds) +
      "&class_id=" +
      "" +
      "&section_id=" +
      "" +
      "&session_id=" +
      session_id +
      "&sample_id=" +
      SELECTED_SAMPLE_ID +
      "&selection_type=" +
      SELECTION_TYPE +
      "&system_code=" +
      process.env.REACT_APP_SYSTEM_CODE +
      "&color_option_id=" +
      COLOR_OPTION_ID +
      "&school_code=" +
      SCHOOL_CODE;

    setFILE_URL(url);
    console.log("FILE_URL", url);
  };

  const changeColor = (index) => {
    setSELECTED_COLOR_POSITION(index);
    setShowStudentIdCard(true);
    setColorOptions(index, mColorOption);
  };

  const changeSample = (position) => {
    setSELECTED_SAMPLE_POSITION(position);
    setSample(position);
  };

  const SelectStudent = () => {
    setIsOpenSelectStudent(true);
  };

  const HandleCloseSelectStudent = () => {
    setIsOpenSelectStudent(false);
  };

  const HandleSelectedStudent = (selectedStudents) => {
    setIsOpenSelectStudent(false);
    setShowStudentIdCard(true);
    setMSelectedStudent(selectedStudents || []);
    setSELECTION_TYPE("student");
    setFileUrL();
  };

  if (!loggedIn) {
    return <Redirect to="/Login" />;
  }

  if (Loading) {
    return <MyLoader />;
  }

  return (
    <div className="content">
      <div
        className="content-header"
        style={{ background: COLORS.primary_color_shade5 }}
      >
        <div className="leftside-content-header">
          <ul className="breadcrumbs">
            <li>
              <i
                className="fa fa-home"
                aria-hidden="true"
                style={{ color: COLORS.white }}
              />
              <a href="#">
                {mPrintableSamples.length !== 0
                  ? "Printable-" + mPrintableSamples[0].document_caption
                  : "Printable"}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div
        className="animated fadeInUpn bg_page_grey_rounded box_shadow"
        style={{ "--mMargin": "50px" }}
      >
        <div className="row">
          <div className="col-sm-6 col-lg-6 padding_0">
            <div
              className="bg_card_primary_outline gravity_center_vertical"
              style={{
                padding: "5px",
                color: "#fff",
                margin: "0px 5px 0px 0px",
              }}
            >
              <div
                className="bg_card_primary gravity_center width_match_parent margin_5 padding_5"
                onClick={SelectStudent}
              >
                <h5 className="arrow"> Select Students Manually</h5>
              </div>
            </div>
          </div>
          <div className="col-sm-6 col-lg-6 padding_0 ">
            <div
              className="bg_card_primary_outline"
              style={{
                padding: "5px",
                color: "#fff",
                margin: "0px 5px 0px 0px",
              }}
            >
              <div
                className="bg_card_primary gravity_center width_match_parent margin_5 padding_5"
                onClick={SelectStudent}
              >
                <h5 className="arrow"> Select Class</h5>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <h5 className="">Sample List</h5>
        </div>
        <div className="row bg_card_grey_outline" style={{ height: "140px" }}>
          {mPrintableSamples.map((item, index) => (
            <div
              key={index}
              className="col-sm-2 col-lg-2 padding_0 height_match_parent"
            >
              <div
                className={
                  SELECTED_SAMPLE_POSITION === index
                    ? "bg_card_green_outline cursor"
                    : "bg_card_grey_outline cursor"
                }
                style={{
                  padding: "1px",
                  color: "#fff",
                  margin: "5px 10px 0px 10px",
                  height: "110px",
                }}
                onClick={() => changeSample(index)}
              >
                <div className="gravity_center img_sample_docs">
                  <img src={item.sample_img} alt="" />
                </div>
              </div>
              <div className="gravity_center">{item.sample_name}</div>
            </div>
          ))}
        </div>

        <div className="row">
          <h5 className="">Color Option</h5>
        </div>
        <div className="row bg_card_grey_outline" style={{ height: "auto" }}>
          {mColorOption.map((item, index) => {
            const [color1, color2] = item.sample_color_code.split("_");
            return (
              <div
                key={index}
                className="col-sm-1 col-lg-1 padding_0 height_match_parent"
              >
                <div
                  className={
                    SELECTED_COLOR_POSITION === index
                      ? "bg_card_green_outline cursor"
                      : "bg_card_grey_outline cursor"
                  }
                  style={{
                    padding: "3px",
                    color: "#fff",
                    margin: "2px",
                    height: "50px",
                  }}
                  onClick={() => changeColor(index)}
                >
                  <div className="gravity_center_row">
                    <div
                      style={{
                        backgroundColor: color1,
                        height: "40px",
                        width: "50%",
                      }}
                    ></div>
                    <div
                      style={{
                        backgroundColor: color2,
                        height: "40px",
                        width: "50%",
                      }}
                    ></div>
                  </div>
                </div>
                <div className="content_center">{item.sample_color_name}</div>
              </div>
            );
          })}
        </div>

        <div className="row">
          <h5 className="">Preview</h5>
        </div>
        <div className="row" style={{ margin: "0px 10px 0px 10px" }}>
          {showStudentIdCard && <MyLoader />}
          <Iframe
            url={FILE_URL}
            width="100%"
            height="800px"
            overflow="visible"
            id="iFrameStudentId"
            className="bg_card_primary_outline"
            display="initial"
            position="relative"
            onLoad={() => setShowStudentIdCard(false)}
          />
        </div>
      </div>

      {isOpenSelectStudent && (
        <MdlSelectMultipleStudent
          actionClose={HandleCloseSelectStudent}
          actionHandleSelected={HandleSelectedStudent}
        />
      )}
    </div>
  );
};

export default PrintableDocs;
